import { GQLKeyPointsFragment } from '@theprintbar/graphql';
import { BrandColours } from '@theprintbar/shared';
import { RichText } from '@theprintbar/ui';

interface KeyPointsProps {
	content: GQLKeyPointsFragment;
}

export function KeyPoints({ content }: KeyPointsProps) {
	const colour = content.keyPointsColour || BrandColours.Blue;

	const splitTextEvenly = (text?: string | null) => {
		if (!text) return null;
		const words = text.split(' ');
		const half = Math.ceil(words.length / 2);
		const firstHalf = words.slice(0, half).join(' ');
		const secondHalf = words.slice(half, words.length).join(' ');

		return [firstHalf, <br />, secondHalf];
	};

	return (
		<div
			className="grid grid-cols-2 lg:grid-cols-4 gap-x-20 gap-y-14 px-4 lg:px-8 py-16 border-y border-blue"
			style={{ backgroundColor: colour }}
		>
			{content.keyPoints.structure?.map(item =>
				item ? (
					<div key={item.title} className="space-y-2.5">
						<img
							loading="lazy"
							alt={item.icon?.altText || 'icon'}
							src={item?.icon?.image.url}
							className="h-5 lg:h-6 xl:h-8 w-auto"
						/>
						<div className="space-y-2.5">
							{/* Split the title evenly across two lines on smaller screens */}
							<p className="lg:hidden text-sm font-display">{splitTextEvenly(item.title)}</p>
							<p className="hidden lg:block text-xl font-display">{item.title}</p>
							<RichText {...item.text} className="text-sm lg:text-base font-light" />
						</div>
					</div>
				) : null,
			)}
		</div>
	);
}
